import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ChatbotService } from './chatbot.service';
import { StatisticService } from './statistic.service';
import { TransferStateService } from './transfer-state.service';
import { LoadingService } from './loading.service';
import { SchoolService } from './school.service';
import { CoreLoader } from './core-loader.service';
import { CoreStateService } from './core-state.service';
import { ScheduleService } from './schedule.service';

@NgModule({
  providers: [
    CoreStateService,
    SchoolService,
    TransferStateService,
    StatisticService,
    ChatbotService,
    LoadingService,
    CoreLoader,
    ScheduleService,
  ],
})
export class CoreServiceModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreServiceModule) {
    if (parentModule) {
      throw new Error('CoreServicesModule has already been loaded. Import CoreServicesModule in the AppModule only.');
    }
  }
}
